import React, { memo, useCallback } from 'react';
import { Button } from '../../Button/Button';
import { Grid, Segment } from 'semantic-ui-react';
import { formatMoney } from '../../../utils/formatters';
import { mapLoanTypeToText } from './utils';
import { LoanIcon } from '../../Icon';
import { LoanModal } from './LoanModal';


var Loan = function (_a) {
    var loan = _a.loan, onLoanClick = _a.onLoanClick;
    var type = loan.type, currencyCode = loan.currencyCode, payments = loan.payments, contractAmount = loan.contractAmount, productName = loan.productName, id = loan.id, installments = loan.installments;
    var handleLoanClick = useCallback(function () {
        onLoanClick === null || onLoanClick === void 0 ? void 0 : onLoanClick(id);
    }, [onLoanClick, id]);
    return (React.createElement(Segment, { className: 'Loan pluggy' },
        React.createElement(Grid, { columns: 7 },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { className: 'product-brand', width: 4 },
                    React.createElement("div", { className: 'product-logo' },
                        React.createElement(LoanIcon, null)),
                    React.createElement("div", { className: 'product-name' },
                        React.createElement("p", { className: 'column-header' }, "Tipo de empr\u00E9stimo"),
                        React.createElement("p", { className: 'ellipsis' }, mapLoanTypeToText(type)))),
                React.createElement(Grid.Column, null,
                    React.createElement("p", { className: 'column-header' }, "Valor contratado"),
                    React.createElement("p", { className: 'ellipsis' }, contractAmount !== null
                        ? formatMoney(contractAmount, currencyCode)
                        : '-')),
                React.createElement(Grid.Column, null,
                    React.createElement("p", { className: 'column-header' }, "Valor atual da d\u00EDvida"),
                    React.createElement("p", null, payments && payments.contractOutstandingBalance !== null
                        ? formatMoney(payments.contractOutstandingBalance, currencyCode)
                        : '-')),
                React.createElement(Grid.Column, null,
                    React.createElement("p", { className: 'column-header' }, "Parcelas a pagar"),
                    React.createElement("p", { className: 'ellipsis' }, installments &&
                        installments.totalNumberOfInstallments !== null &&
                        installments.paidInstallments !== null
                        ? installments.totalNumberOfInstallments -
                            installments.paidInstallments + " de " + installments.totalNumberOfInstallments
                        : '-')),
                React.createElement(Grid.Column, null,
                    React.createElement("p", { className: 'column-header' }, "Nome"),
                    React.createElement("p", { className: 'ellipsis' }, productName)),
                React.createElement(LoanModal, { loan: loan, trigger: React.createElement(Grid.Column, { textAlign: 'right', verticalAlign: 'middle', onClick: handleLoanClick },
                        React.createElement(Button, { link: true }, "Veja detalhes")) })))));
};
export default memo(Loan);
